// removed by extract-text-webpack-plugin
module.exports = {"component":"AdminHeader__component___1I7j9","wrapper":"AdminHeader__wrapper___3yC8l","logo":"AdminHeader__logo___1URfq","logoutLink":"AdminHeader__logoutLink___20Tad"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/components/AdminHeader.css
// module id = 307
// module chunks = 0